export enum SubscriptionStatus {
    ACTIVE = 'ACTIVE',
    UNDER_GRACE_PERIOD = 'UNDER_GRACE_PERIOD',
    EXPIRED = 'EXPIRED',
    TRIAL_EXPIRED = 'TRIAL_EXPIRED',
    RENEWAL_LOCKED = 'RENEWAL_LOCKED',
    UNDER_RENEWAL = 'UNDER_RENEWAL',
    UNKNOWN = 'UNKNOWN'
}
